<div class="row">
  <div class="col-12">
    <rask-input label="Avtalsobjekt" value="{{selectedAvtalsobjekt?.deliverySourceNumber}}" [readonly]="true"></rask-input>
    <rask-input label="Extern referens" value="{{selectedAvtalsobjekt?.documentNumber}}" [readonly]="true"></rask-input>
    <rask-input label="Status" value="{{selectedAvtalsobjekt?.deliverySourceValidityStatus}}" [readonly]="true"></rask-input>
    <rask-input label="Datum" value="{{selectedAvtalsobjekt?.deliverySouceDate}}" [readonly]="true"></rask-input>
    <rask-input label="Giltig from" value="{{selectedAvtalsobjekt?.validityPeriodFrom}}" [readonly]="true"></rask-input>
    <rask-input label="Giltig tom" value="{{selectedAvtalsobjekt?.validityPeriodTom}}" [readonly]="true"></rask-input>
    <rask-input label="Koord avlägg" value="{{avlagg}}" [readonly]="true"></rask-input>
    <rask-input label="LLD" value="{{selectedAvtalsobjekt?.supplyingRegistrationDistrictCode}}" [readonly]="true"></rask-input>
    <rask-input label="Fraktsedel" value="{{selectedAvtalsobjekt?.billOfLadingNumber}}" [readonly]="true"></rask-input>
    <rask-input label="Utsläpp på Eus marknad" value="{{selectedAvtalsobjekt?.firstReleaseOnEuMarket}}" [readonly]="true"></rask-input>
    <rask-input label="Ursprungsland" value="{{selectedAvtalsobjekt?.countryOfHarvest}}" [readonly]="true"></rask-input>

  </div>
</div>

<hr>

  <div class="row">
    <div class="col-12">
      <div class="col-header">
        Destinerasortiment
      </div>
    </div>
  </div>
  <div class="row preview-table-wrapper">
    @if (selectedAvtalsobjekt?.orderConfirmation?.orderConfirmationLineItems?.length > 0) {
      <div class="col-12">
        <rask-table customStyle="structured-readonly" [data]="selectedAvtalsobjekt.orderConfirmation.orderConfirmationLineItems" [columns]="orderConfirmationtableColumns"></rask-table>
      </div>
    }
  </div>

  <hr>

    @if (selectedAvtalsobjekt?.forestLoggingInstructions?.length > 0) {
      <div class="row">
        <div class="col-12">
          <div class="col-header">
            Produktionsunderlag
          </div>
        </div>
      </div>
    }
    @if (selectedAvtalsobjekt?.forestLoggingInstructions?.length > 0) {
      <div class="row preview-table-wrapper">
        @if (serviceInstructionLines?.length > 0) {
          <div class="col-12">
            <rask-table customStyle="structured-readonly" [data]="serviceInstructionLines" [columns]="serviceIntructionColums"></rask-table>
          </div>
        }
      </div>
    }

    <hr>

      <div class="row">
        <div class="col-12">
          <div class="col-header">
            Transportunderlag
          </div>
        </div>
      </div>
      <div class="row preview-table-wrapper">
        @if (loadtenders?.length > 0) {
          <div class="col-12">
            <rask-table customStyle="structured-readonly" [data]="loadtenders" [columns]="loadtenderColumns"></rask-table>
          </div>
        }
      </div>
